import ConfirmOrderModalContainer from './ConfirmOrderModalContainer';

export default ConfirmOrderModalContainer;
